export class HandlingUnitTrackingLoad {
  public static readonly type = '[HandlingUnitOverview] Load Tracking';
  constructor(
    public payload: {
      deliveryNoteNumber: string;
      handlingUnitNumber: string;
    },
  ) {}
}

export class HandlingUnitOverviewLoad {
  public static readonly type = '[HandlingUnitOverview] Load Overview';
  constructor(
    public payload: {
      deliveryNoteNumber: string;
      handlingUnitNumber: string;
    },
  ) {}
}

export class HandlingUnitOverviewInitialState {
  public static readonly type = '[HandlingUnitOverview] Set Initial State';
}
